module.exports = __webpack_public_path__ + "static/scale-model-of-cedar-rapids-iowa-ae44067ce7372f3979921de014f5b273.png";